<script setup>
import { onMounted, ref, useTemplateRef } from 'vue';
import IconoModalidad from './IconoModalidad.vue';
import { precio } from '@/libs/cifra/importes';

const props = defineProps({
  modelValue: { type: [Number, String, Array], default: undefined },
});
const emits = defineEmits(['update:modelValue']);
const select2Input = useTemplateRef('selector');

const modalidad = ref();

function modelUpdated() {
  const selectedData = select2Input.value.selectedData();
  if (selectedData.length > 0) {
    modalidad.value = selectedData[0];
  } else {
    modalidad.value = null;
  }
}
</script>

<template>
  <div class="wrapper-selector-modalidad">
    <div>
      <SelectorModalidad
        ref="selector"
        :model-value="modelValue"
        :multiple="false"
        @update:model-value="modelUpdated"
        @modalidades-cargadas="modelUpdated"
        v-bind="$attrs"
      ></SelectorModalidad>
    </div>
    <div v-if="modalidad">
      <IconoModalidad :modalidad="modalidad" class="m-r-xs fa-13x"/>
      <div class="label label-success text-12x">{{ precio(modalidad.importe_con_iva) }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/../assets/stylesheets/cifra/vars/main.scss";

.wrapper-selector-modalidad {
  display: flex;
  align-items: center;

  > div:first-child {
    flex: 1
  }

  > div:last-child {
    padding-left: $margin-sm;
  }
}
</style>